export enum BuilderMessageType {
  BUILD_PRICE = "buildPrice",
  CHANGE_REQUEST = "changeRequest",
}
